var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJjIconWriteBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.37 6.73L13.75 6.11L13.665 6.025L11.005 8.68501L9.51001 7.19L12.17 4.53L11.82 4.18L11.51 3.87L11.46 3.82L8.80001 6.48L7.32501 5L9.98501 2.34L9.89501 2.25L9.27501 1.63L6.21501 4.69L6.13501 4.805L1.63501 13.66L2.34001 14.365L11.21 9.86L11.325 9.78L14.37 6.73ZM6.26001 11.25C5.69001 11.54 5.34001 11.715 4.93501 11.31L4.77001 11.145L4.60001 10.98C4.28001 10.655 4.46001 10.315 4.74501 9.74L6.73501 5.83L10.175 9.27001L6.26001 11.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJjIconWriteBlackRgb);
export default __webpack_public_path__ + "static/media/JJ_Icon_Write_Black_RGB.eb812f1c18be63ce3ab6f65a0c2f563d.svg";
export { ForwardRef as ReactComponent };